import {
    IGptContextState,
    GptContextDispatchMessage,
    GptContextDispatchMessageType
} from "./GptContext.interfaces";
import { IGpt } from "Interfaces/Gpt";

export const initialState: IGptContextState = {
    loaded: false,
    list: new Array<IGpt>(),
}

export const reducer = (prevState: IGptContextState, payloads: Array<GptContextDispatchMessage>): IGptContextState => {
    const newState: IGptContextState = {...prevState};
    payloads.forEach(payload => {
        const payloadType = payload.type;
        switch (payloadType) {
            case GptContextDispatchMessageType.SetList:
                newState.list = payload.list;
                break;
            case GptContextDispatchMessageType.SetLoaded:
                newState.loaded = payload.value;
                break;
            default:
                throw new Error("Message " + GptContextDispatchMessageType[payloadType] + " not implemented");
        }
    });
    return newState;
}